import React from "react";

import { GrUserWorker } from "react-icons/gr";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { FaHandshake } from "react-icons/fa";
import { MdLocationCity } from "react-icons/md";

const About = () => {
  return (
    <div>
      <div className="banner">
        <img src="assets/img/about.jpg"></img>
      </div>
      <section id="about" class="about section">
        <div class="container" data-aos="fade-up" data-aos-delay="100">
          <div class="row align-items-xl-center gy-5">
            <div class="content">
              <h3>About Us</h3>
              <h2>Fenice Shield Chemicals  Pvt. Ltd.</h2>
              <p>
              We are a leading provider of professional waterproofing solutions, dedicated to protecting your home or business from water damage and ensuring long-lasting durability. With years of industry experience, we specialize in delivering high-quality waterproofing services for a variety of structures, including terraces, basements, bathrooms, swimming pools, and more. Our team of certified experts uses advanced techniques and premium materials to safeguard your property against leaks, moisture, and dampness.
              </p>
              {/* <Link to="#" class="read-more">
                <span>Read More</span>
                <i class="bi bi-arrow-right"></i>
              </Link> */}
            </div>
{/* 
            <div class="content">
              <h3>About Our C.E.O</h3>
              <h2>Mr. M.E. Suresh B.COM P.G.DMM</h2>
              <p>
                He, Mr.M.E.Suresh from Thiruvallur, he had experienced more than
                20 years in various sectors, his journey starts from a small
                village to an entrepreneur and still continuing successfully.
              </p>
              {/* <Link to="#" class="read-more">
                <span>Read More</span>
                <i class="bi bi-arrow-right"></i>
              </Link> */}
            {/* </div>  */}
            {/* <div className="stats-section">
              <div className="stat-item">
                <GrUserWorker className="stat-icon" />
                <h5 className="stat-number">1500</h5>
                <div className="stat-title">Happy Employees</div>
              </div>

              <div className="stat-item">
                <MdOutlineMiscellaneousServices className="stat-icon" />
                <h5 className="stat-number">30</h5>
                <div className="stat-title">Our Services</div>
              </div>

              <div className="stat-item">
                <FaHandshake className="stat-icon" />
                <h5 className="stat-number">50</h5>
                <div className="stat-title">Our Clients</div>
              </div>

              <div className="stat-item">
                <MdLocationCity className="stat-icon" />
                <h5 className="stat-number">6</h5>
                <div className="stat-title">Service Locations</div>
              </div>
            </div> */}

            <div class="content">
              <h3>Our vision</h3>
              <p>
              Our vision is to become the most trusted and innovative waterproofing company, known for delivering exceptional, long-lasting solutions that protect properties from water damage. We aim to set industry standards for quality, sustainability, and customer satisfaction while continuously improving our techniques and services to meet evolving market demands.
              </p>
              {/* <Link to="#" class="read-more">
                <span>Read More</span>
                <i class="bi bi-arrow-right"></i>
              </Link> */}
            </div>

            <div class="content">
              <h3>Our mission</h3>
              <p>
              Our mission is to provide reliable, high-quality waterproofing solutions that safeguard homes and businesses from water infiltration and damage. We are committed to using the best materials and the latest technologies to deliver durable, cost-effective, and environmentally friendly services. Through integrity, professionalism, and customer-focused service, we strive to create safe, dry, and secure environments for our clients while fostering long-term relationships built on trust and satisfaction.
              </p>
              {/* <Link to="#" class="read-more">
                <span>Read More</span>
                <i class="bi bi-arrow-right"></i>
              </Link> */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
